<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr v-for="(item, index) in desserts" :key="item.name">
          <th class="text-left pl-1 py-2" :class="index === 0 ? 'th_top' : ''">{{ item.name }}</th>
          <td class="text-left pl-1 py-2" :class="index === 0 ? 'td_top' : ''">{{ item.value }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import config from '../../config'
export default {
  data: () => ({
  }),
  computed: {
    // 単語ページ範囲
    isShowPagesTango() {
      return this.$store.getters['conditions/isShowPagesTango']
    },
    // 連語ページ範囲
    isShowPagesRengo() {
      return this.$store.getters['conditions/isShowPagesRengo']
    },
    desserts() {
      // 保存問題の場合
      if (this.$store.state.conditions.savePrintMode) {
        return this.$store.state.conditions.conditionDetails
      }

      // 保存問題でない場合
      let array = []
      //教科書・単語集
      if(this.$store.state.conditions.selectedSearchType===1)
        array.push({
          name: '教科書',
          value: this.$store.state.master.allPublishers.find(x=>x.value===this.$store.state.conditions.selectedTextbook).text
        },
        {
          name: '学年',
          value: this.$store.state.master.allGrades.find(x=>x.value===this.$store.state.conditions.selectedGrade).text
        })
      else if(this.$store.state.conditions.selectedSearchType===2)
        array.push({
          name: '単語集',
          value: 'ゲットスルー2600'
        })
      //出題対象
      let targetValues = []
      this.$store.state.conditions.checkedArr['target'].forEach(x=>{
        targetValues.push(config.targets[x])
      })
      if(this.$store.state.conditions.checkedArr['katsuyo'].length !== 0) targetValues.push('活用語')
      if(this.$store.state.conditions.checkedArr['reibun'].length !== 0) targetValues.push('例文')
      if(this.$store.state.conditions.checkedArr['hanigo'].length !== 0) targetValues.push('反意語')
      targetValues = targetValues.join("、")

      //TODO:活用後、反意語のみの場合の表示を考える必要あり
      array.push({
        name: '出題対象',
        value: targetValues.replace(/、\s*$/, "")
      })
      //範囲
      if(this.$store.state.conditions.selectedCategory===3) {//テーマ範囲
        array.push({
          name: 'テーマ範囲',
          value: this.createThemeNames()
        })
      }

      if(this.$store.state.conditions.selectedQuestionRangeType===1) {//ページ範囲
        let tangoRanges = ''
        this.$store.state.conditions.selectedQuestionRangePage.tango.forEach(x=>{
          tangoRanges+=x.start+'~'+x.end+'ページ、'
        })
        let rengoRanges = ''
        this.$store.state.conditions.selectedQuestionRangePage.rengo.forEach(x=>{
          rengoRanges+=x.start+'~'+x.end+'ページ、'
        })

        // 教科書は表示、ゲットスルーの時は単語が選ばれていたら表示
        if (this.isShowPagesTango){
          array.push({
            name: 'ページ範囲(単語)',
            value: tangoRanges.replace(/、\s*$/, ""),
          })
        }

        //教科書は非表示、ゲットスルーは連語が選ばれていたら表示
        if (this.isShowPagesRengo){
          array.push({
            name: 'ページ範囲(連語)',
            value: rengoRanges.replace(/、\s*$/, ""),
          })
        }

      } else if(this.$store.state.conditions.selectedQuestionRangeType===2) {//単元範囲
        array.push({
          name: '単元範囲',
          value: this.createUnitNames()
        })
      } else if(this.$store.state.conditions.selectedQuestionRangeType===3) {//見出し範囲
        let tangoRanges = ''
        this.$store.state.conditions.selectedQuestionRangeMidashi.tango.forEach(x=>{
          tangoRanges+='見出し'+x.start+'~'+x.end+'、'
        })
        let rengoRanges = ''
        this.$store.state.conditions.selectedQuestionRangeMidashi.rengo.forEach(x=>{
          rengoRanges+='見出し'+'C'+x.start+'~'+'C'+x.end+'、'
        })
        if (this.isShowPagesTango) {
          array.push({
            name: '見出し範囲(単語)',
            value: tangoRanges.replace(/、\s*$/, ""),
          })
        }
        if (this.isShowPagesRengo) {
          array.push({
            name: '見出し範囲(連語)',
            value: rengoRanges.replace(/、\s*$/, ""),
          })
        }
      }
      //共通
      let questionNums = ''
      Object.entries(this.$store.state.conditions.questionNumAreas)
        .forEach(([, area], index)=> {
          if(area.value>0 && area.displayFlg) {
            let settingText = ''
            if(area.maxAvailableWordNum < area.value) {
              settingText = config.questionTypeText[index+1]+':'+area.maxAvailableWordNum+'問(<指定設問数 '+area.value+')、'
            } else {
              settingText = config.questionTypeText[index+1]+':'+area.value+'問、'
            }
            questionNums+=settingText
          }
        })
      array.push(
        {
          name: '設問数',
          value: questionNums.replace(/、\s*$/, "") //末尾の「、」を削除
        },
        {
          name: 'ソート',
          value: config.sortTypeText[this.$store.state.conditions.selectedSearchType][this.$store.state.conditions.selectedQuestionSortType],
        })
      if(this.$store.state.conditions.selectedSearchType===2)
        array.push({
          name: '解説',
          value: config.descriptionType[this.$store.state.conditions.selectedQuestionDescription],
        })
      if (this.$store.state.user.hasLogo){
        array.push(
          {
            name: 'ロゴ',
            value: this.$store.state.conditions.selectedLogoFlg ? 'あり' : 'なし'
          })
      }
      return array
    }
  },
  methods: {
    groupBy(array, getKey){
      return array.reduce((obj, cur, idx, src) => {
          const key = getKey(cur, idx, src);
          (obj[key] || (obj[key] = [])).push(cur);
          return obj;
      }, {})
    },
    createUnitNames() {
      const units = this.$store.getters['conditions/selectedUnits']
      // 親単元でグルーピング
      const parentGroups = this.groupBy(units, unit => unit.parentId)
      const unitNames =  Object.entries(parentGroups).map(([parentId, children]) => {
        // ゲットスルー単元は子階層がないため親の名前を返す
        if (parentId === 'undefined') return children.map(child => child.shortText).join('、')

        const parent = this.$store.state.master.allUnits.find(unit => unit.id == parentId)
        const isSelectedAllChildren = parent.children.length === children.length
        // 子供単元が全部選択されていたら親の shortTextを返す
        if (isSelectedAllChildren) {
          return parent.shortText
        } else {
          return `${parent.shortText}(${children.map(child => child.shortText).join(',')})`
        }
      })
      return unitNames.join('、')
    },
    createThemeNames() {
      const themes = this.$store.getters['conditions/selectedThemes']
      // 親単元でグルーピング
      const parentGroups = this.groupBy(themes, theme => theme.parentId)
      const themeNames =  Object.entries(parentGroups).map(([parentId, children]) => {
        const parent = this.$store.state.master.allThemes.find(theme => theme.id == parentId)
        const isSelectedAllChildren = parent.children.length === children.length
        // 子供単元が全部選択されていたら親のtextを返す
        if (isSelectedAllChildren) {
          return parent.text
        } else {
          return `${parent.text}(${children.map(child => child.text).join(',')})`
        }
      })
      return themeNames.join('、')
    }
  }
}
</script>

<style lang="stylus" scoped>
  th
    background-color: #efefef;
    font-size 14px !important
    min-width 80px
  .th_top
    border-top #3872b0 4px solid
  .td_top
    border-top #b3b3b3 4px solid
</style>
